//@flow

//don't use [5] unless life throws you lemons (and you ran out of gin and ginger beer)
exports.zIndices = ['0', '10', '20', '30', '40', '50', '1000000']
